import { Routes } from '@angular/router';
import { PanelclientComponent } from './panelclient.component';
import { guardsClientGuard } from '../guards/guards-client.guard';
import { RelatorioComponent } from './disparos/relatorio/relatorio.component';
import { LoginComponent } from '../../login/login.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { clientInterceptorInterceptor } from '../client-interceptor.interceptor';
import { AgendasComponent } from './agendas/agendas.component';
import { DisparosComponent } from './disparos/disparos.component';
import { ListasComponent } from './listas/listas.component';
import { NutricoesComponent } from './nutricoes/nutricoes.component';
import { MessagesComponent } from './messages/messages.component';
import { BloqueadosComponent } from './bloqueados/bloqueados.component';
import { CanaisComponent } from './canais/canais.component';
import { ProfileComponent } from './profile/profile.component';
import { EkuroIntegracaoComponent } from './ekuro-integracao/ekuro-integracao.component';
import { agendaGuardGuard } from './agendas/guards/agenda-guard.guard';
import { ViewAgendaComponent } from './agendas/view-agenda/view-agenda.component';
import { DocumentationapiComponent } from './agendas/documentationapi/documentationapi.component';
import { TermInfoComponent } from '../term-info/term-info.component';
import { randomRouteGuard } from '../guards/randomRoute.guard';
import { BlankComponent } from './blank/blank.component';
import { guardBasic } from '../guards/guard-basic.guard';
import { ClinicorpMenuComponent } from './clinicorp-menu/clinicorp-menu.component';
import { guardClinicorp } from '../guards/guard-clinicorp.guard';

export const clientRoutes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },

  {
    path: 'app',
    providers: [
      provideHttpClient(withInterceptors([clientInterceptorInterceptor])),
    ],
    //canActivate: [],
    canActivateChild: [guardsClientGuard],
    component: PanelclientComponent,
    children: [
      {
        path: '',
        component: BlankComponent,
        canActivate: [randomRouteGuard],
        pathMatch: 'full',
      },
      {
        path: 'disparos',
        component: DisparosComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'agendas',
        component: AgendasComponent,
        canActivate: [agendaGuardGuard],
      },
      {
        path: 'agendas/view/:id',
        component: ViewAgendaComponent,
        canActivate: [agendaGuardGuard],
      },
      {
        path: 'listas',
        component: ListasComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'nutricoes',
        component: NutricoesComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'mensagens',
        component: MessagesComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'canais',
        component: CanaisComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'perfil',
        component: ProfileComponent,
      },
      {
        path: 'bloqueados',
        component: BloqueadosComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'clinicorp-menu',
        component: ClinicorpMenuComponent,
        canActivate: [guardClinicorp]
      },
      {
        path: 'ecuro',
        component: EkuroIntegracaoComponent,
      },
      {
        path: 'disparo/:iddisparo',
        component: RelatorioComponent,
        canActivate: [guardBasic]
      },
      {
        path: 'termo-disparo-oficial',
        component: TermInfoComponent
      }
    ],
  },
  {
    path: 'api-documentation',
    component: DocumentationapiComponent,
  },
];
